<ng-container>

  @if (this.templates.length == 0) {
    <div class="section">
      <h1>No available templates for this user.</h1>
    </div>
  }

  @if (this.templates.length > 0) {
    <div class="section">
      <h1>Upload Templates</h1>
      @for (file of templates; track file) {
        <a mat-raised-button target="_blank" href="/downloads/{{file.filename}}"
          class="template-btn" title="{{file.filename}}">
          <mat-icon>{{file.icon}}</mat-icon>
          <span class='template-btn-text'>{{file.description}}</span>
        </a>
      }
    </div>
  }

</ng-container>